import React, { createContext, useContext, useEffect, useState } from 'react';

const A11yContext = createContext(null);

export function A11yProvider({ children }) {
  const [fontScale, setFontScale] = useState(() => Number(localStorage.getItem('a11y_font') || 1));
  const [highContrast, setHighContrast] = useState(() => localStorage.getItem('a11y_hc') === '1');
  const [plainLanguage, setPlainLanguage] = useState(() => localStorage.getItem('a11y_pl') === '1');

  useEffect(() => {
    document.documentElement.style.setProperty('--font-scale', String(fontScale));
    localStorage.setItem('a11y_font', String(fontScale));
  }, [fontScale]);

  useEffect(() => {
    document.documentElement.classList.toggle('high-contrast', highContrast);
    localStorage.setItem('a11y_hc', highContrast ? '1' : '0');
  }, [highContrast]);

  useEffect(() => {
    localStorage.setItem('a11y_pl', plainLanguage ? '1' : '0');
  }, [plainLanguage]);

  return (
    <A11yContext.Provider value={{ fontScale, setFontScale, highContrast, setHighContrast, plainLanguage, setPlainLanguage }}>
      {children}
    </A11yContext.Provider>
  );
}

export const useA11y = () => useContext(A11yContext);
